import {createApp} from 'vue'
// @ts-ignore
import Success from "@/pages/success/Success.vue";

const main = createApp(Success);

main.mount('#m-checkout-success');
